import React, { Suspense } from 'react';

import PAGES_CONST from 'application/pages/constants';

import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

const Renderer = React.lazy(() => import('./renderer'));

const IntegrationPageWrapper = () => (
  <Suspense fallback={<LoadingScreen delay={PAGES_CONST.LOADER_SCREEN_DELAY} />}>
    <Renderer />
  </Suspense>
);

export default IntegrationPageWrapper;
